import React from 'react';

import SearchFilter from 'components/Filters/SearchFilter';

import './styles.css';

interface SubNavigationProps {
  filters: any;
  setFilter: (field, value) => void;
}

class SubNavigation extends React.Component<SubNavigationProps> {
  render() {
    return (
      <div className="SubNavigation colab-sidepadding-2 colab-centered">
        <SearchFilter
          value={this.props.filters.search}
          onChange={(search: string) => this.props.setFilter('search', search)}
        />
      </div>
    );
  }
}

export default SubNavigation;
